import React, { useState, useEffect } from 'react';
import UserModule from '../Users/UserModule';
import { useAuth } from '../../AuthContext';
import StaffProfile from '../Faculty/StaffProfile';
import CircularProgress from '@mui/material/CircularProgress';
import configData from '../../configure';

function Admin({ orgId }) {
  const { axios, userRole, user } = useAuth();
  const [singleStaff, setSingleStaff] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      if (userRole === 'ADMIN' && user?.userId) {
        setLoading(true);
        try {
          const response = await axios.get(
            `${configData.GET_USER_DETAILS}/${user.userId}`,
            { headers: { accept: 'application/json' } }
          );
          if (response.data) {
            setSingleStaff({
              ...response.data.user,
              rawData: response.data,
              employeeId: response.data.staffInfo?.employeeId || 'N/A',
            });
          }
        } catch (err) {
          setError(err.message);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchProfile();
  }, [userRole, user?.userId, axios]);

  // If the user is an admin viewing their own role's list OR managing admins
  // In the navigation, "Admin" usually means managing admin users
  return <UserModule userType="ADMIN" orgId={orgId} />;
}

export default Admin;